// demo requested radio btn option in webinar form
var demoRequestOption = document.getElementById('demo-request-option'),
  demoRequestOptHeight = demoRequestOption ? demoRequestOption.offsetHeight : 0;

if (demoRequestOptHeight) {
  var demoRequestMessage = 'Not Selected';
}

var webinarBannerJs = (function() {
  var csrf_token;

  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    var custModalOverlay = document.querySelector(
      ".webinar-banner__video-trigger"
    );
    if (custModalOverlay) {
      var custModalVideoId = custModalOverlay.getAttribute("data-video-id"),
        ua = navigator.userAgent.toLowerCase(),
        isSafari = false,
        sandboxFlag = '';

      // Detect browser for allow presentation sandbox flag
      try {
        isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
      }
      catch(err) {}
      isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
      sandboxFlag = isSafari ? '' : 'allow-presentation';

      custModalOverlay.addEventListener("click", function(e) {
        e.preventDefault();
        if (custModalVideoId) {
          var custModalVideo = new tingle.modal({
            closeIconInverse: true,
            cssClass: ['popup-video'],
            onClose: function() {
              custModalVideo.destroy();
            }
          });
          custModalVideo.setContent(
            '<iframe width="100%" height="400" src="https://www.youtube.com/embed/' +
              custModalVideoId +
              '?autoplay=1" frameborder="0" sandbox="allow-scripts allow-same-origin ' + sandboxFlag + '" allowfullscreen></iframe>'
          );
          custModalVideo.open();
        }
      });
    }

    var timezoneDiv = document.querySelector(".webinar-banner__tag-timezone");
    if (timezoneDiv) {
      var timezoneObj = timezoneDiv.dataset,
        month = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
        webinarDateDiv = document.querySelector(".webinar-banner__tag-timedate"),
        webinarTimeDiv = document.querySelector(".webinar-banner__tag-timezone");
    
      function formateDateNth(d) {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      }
    
      function formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      }
    
      if (timezoneObj.timezoneCode !== "" && webinarDateDiv && webinarTimeDiv) {
        var dateObj = new Date(timezoneObj.timezoneDatetime),
          clientTimeStr = dateObj.toString(),
          clientTimeZone = clientTimeStr ? (clientTimeStr.match(/\(([A-Za-z\s].*)\)/) ? clientTimeStr.match(/\(([A-Za-z\s].*)\)/)[1] : '') : '';
    
        //Get timezone short form
        var split_names = clientTimeZone ? clientTimeZone.trim().split(" ") : '';
        if (split_names.length > 1) {
          clientTimeZone = "";
          for (var i = 0; i < split_names.length; i++) {
            clientTimeZone += split_names[i].charAt(0);
          }
        }
    
        //Update Date
        webinarDateDiv.innerHTML =
          dateObj.getDate() +
          formateDateNth(dateObj.getDate()) +
          " " +
          month[dateObj.getMonth()] +
          " " +
          dateObj.getFullYear();
    
        //Update Time
        webinarTimeDiv.innerHTML = formatAMPM(dateObj) + " " + clientTimeZone;
      }
    }

    //Show user state
    var userStateForEvent = document.getElementById("webinar-user_state_for_event")
    if (userStateForEvent && Cookie.read(userStateForEvent.value)) {
      document.body.classList.add("eventSummit-variation");
    }
  };

  // Set the page URL hidden field with page url value
  var getCurrentPageURL = window.location.href,
    getPageURLInput = document.getElementById("form-page-url");
  
  if (getPageURLInput) {
    getPageURLInput.value = getCurrentPageURL.trim();
  }
  
  // Select box for Bstack Orignals Form.
  if (document.getElementById("form-function")) {
    new ChosenCustom({
      selector: document.getElementById("form-function"),
      ID: "selectFunction",
      placeholder: "Function *"
    });
  }

  // Select box for Bstack Orignals Form.
  if (document.getElementById("form-workex-field")) {
    new ChosenCustom({
      selector: document.getElementById("form-workex-field"),
      ID: "selectWorkExField",
      placeholder: "Work Experience"
    });
  }

  if (document.getElementById("form-country")) {
    new ChosenCustom({
      selector: document.getElementById("form-country"),
      ID: "selectFunction",
      placeholder: "Country"
    });
  }

  // Select box for catapult form
  if (document.getElementById("form-graduation")) {
    new ChosenCustom({
      selector: document.getElementById("form-graduation"),
      ID: "selectGraduation",
      placeholder: "Year of Graduation*"
    });
  }

  //for meetup form
  if (document.getElementById("work-experience")) {
    new ChosenCustom({
      selector: document.getElementById("work-experience"),
      ID: "selectWorkExperience",
      placeholder: "Work Experience*"
    });
  }

  var emailField = document.getElementById("form-email");
  if (emailField) {
    //focus 
    emailField.addEventListener('focus', function() {
      var that = this,
      emailError = document.getElementById("email-error");
      
      //remove existing error
      if (emailError) {
        emailError.remove();
      }

      that.classList.remove("error-border");

      if (!csrf_token) {
        // XHR request for user token
        bsLib.ajax(
          "GET",
          bsLib.railsHost() + "/user/token.json",
          {},
          false,
          {},
          // Success message for user token.
          function(data) {
            var dataRequest = bsLib.JSONParse(data.response);
            csrf_token = dataRequest.csrf_token;
          },
          // Custom Error message for user token.
          function() {
            return "user token not working";
          }
        );
      }
    });

    emailField.addEventListener("blur", function(event) {
      var validEmail = true,
      that = this,
      submitBtn = document.getElementById("commit"),
      emailError = document.getElementById("email-error"),
      pageSlug = window.location.pathname,
      pageSlug = pageSlug.replace(/^\/|\/$/g, "");

      //false valid dataset
      that.dataset.notvalid = "0";

      //remove existing error
      if (emailError) {
        emailError.remove();
      }

      if (that.value.trim().length == 0 || !bsLib.validEmail(that.value.trim())) {
        validEmail = false;
        
        that.classList.add("error-border");
        that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + (that.value.trim().length == 0 ? Messages.salesAndSupportPage.noemail: Messages.salesAndSupportPage.invalidEmail) + '</span>');
      } else {
        that.classList.remove("error-border");
      }

      if (validEmail) {
        //Disable submit button
        if (submitBtn) {
          submitBtn.setAttribute("disabled", "disabled");
          submitBtn.dataset.valueText = submitBtn.value;
          submitBtn.value = Messages.salesAndSupportPage.validateText;
        }
        var formId = document.getElementById("form-id"),
          bstackAPI,
          emailErrorMsg;

        if (pageSlug === 'events/breakpoint') {
          bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value.trim()) + "&event=breakpoint";
          emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
        } else if (formId.value === "browserstack-day" || formId.value === "webinars") {
          bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value.trim()) + "&source=paid_ads";
          emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail;
        } else {
          bstackAPI = bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value.trim());
          emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
        }
        
        bsLib.ajax(
          "GET",
          bstackAPI,
          {},
          true,
          {
            "X-CSRF-Token": csrf_token,
            "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
          },
          function(data) {
            var dataRequest = bsLib.JSONParse(data.response);

            //remove disable
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.value = (formId.value === "webinars") ? submitBtn.dataset.btntext : submitBtn.dataset.valueText;
            }
            
            if (dataRequest.valid === false) {
              that.dataset.notvalid = "1";

              that.classList.add("error-border");
              if (that.parentNode.getElementsByClassName("error-message").length === 0) {
                that.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + emailErrorMsg + '</span>');
              }
            }
          },
          function() {}
        );
      }
    });
  }

  // Email validation for Testathon email2 and email3 fields
  var emailFieldTwo = document.getElementById("form-email-two"),
    emailFieldThree = document.getElementById("form-email-three");

  if (emailFieldTwo && emailFieldThree) {
    emailFieldTwo.addEventListener("blur", checkEmailValidation);
    emailFieldThree.addEventListener("blur", checkEmailValidation);

    function checkEmailValidation() {
      var that = this,
        submitBtn = document.getElementById("commit"),
        emailError = that.nextElementSibling;

      //false valid dataset
      that.dataset.notvalid = "0";

      //remove existing error
      if (emailError) {
        emailError.remove();
        that.classList.remove("error-border");
      }

      if (that.value.trim().length !== 0) {
        //Disable submit button
        if (submitBtn) {
          submitBtn.setAttribute("disabled", "disabled");
          submitBtn.dataset.valueText = submitBtn.value;
          submitBtn.value = Messages.salesAndSupportPage.validateText;
        }
        
        bsLib.ajax(
          "GET",
          bsLib.railsHost() + "/marketing_api/check_email_validation?email=" + encodeURIComponent(that.value.trim()),
          {},
          true,
          {
            "X-CSRF-Token": csrf_token,
            "content-type": "application/x-www-form-urlencoded; charset=utf-8" // Setting content type.
          },
          function(data) {
            var dataRequest = bsLib.JSONParse(data.response);

            //remove disable
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.value = submitBtn.dataset.valueText;
            }
            
            if (dataRequest.valid === false) {
              that.dataset.notvalid = "1";

              that.classList.add("error-border");
              var errorCount = that.parentNode.getElementsByClassName("error-message").length;
              if (errorCount === 0) {
                that.insertAdjacentHTML('afterend', '<span class="error-message">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
              }
            }
          },
          function() {}
        );
      }
    }
  }

  // phone no validation on blur
  var phoneNoField = document.getElementById('form-phone');
  if (phoneNoField) {
    phoneNoField.addEventListener("blur", checkPhoneNoValidation);

    function checkPhoneNoValidation() {
      var that = this,
        phoneNoError = that.nextElementSibling;

      //false valid dataset
      that.dataset.notvalid = "0";

      //remove existing error
      if (phoneNoError) {
        phoneNoError.remove();
      }

      if (that.value.trim().length === 0 || !bsLib.validPhoneNo(that.value.trim())) {
        that.dataset.notvalid = "1";
        that.classList.add("error-border");
        var phoneErrorCount = that.parentNode.getElementsByClassName("error-message").length;
        if (phoneErrorCount === 0) {
          that.insertAdjacentHTML('afterend', '<span class="error-message" id="phone-error">' + (that.value.trim().length == 0 ? Messages.phoneNoValidationErrors.noPhoneNo : Messages.phoneNoValidationErrors.invalidPhoneNo) + '</span>');
        }
      } else {
        that.classList.remove("error-border");
      }
    }
  }

  // Demo radio option for Webinar form
  if (demoRequestOption) {
    var radioElemField = demoRequestOption.querySelectorAll('.input-radiobox');
    for (var j = 0; j < radioElemField.length; j++) {
      radioElemField[j].addEventListener('change', function() {
        demoRequestMessage = this.value;
      });
    }
  }

  init();
})();

/**
 * Recaptcha File load
 */
window.addEventListener("load", function() {
  // reset radio button field on load
  if (demoRequestOption) {
    var radioElemField = demoRequestOption.querySelectorAll('.input-radiobox');
    for (var j = 0; j < radioElemField.length; j++) {
      radioElemField[j].checked = false;
    }
  }

  // load recaptcha JS after page load
  document.addEventListener("click", function (e) {
    var contactformcaptcha = document.getElementById("recaptcha-js"),
      webinarFormID = document.getElementById('form-id');
    
    if (!contactformcaptcha && typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }
    //load zoominfo JS
    if (!e.target.closest('.open-webinar-modal-form') && (webinarFormID ? (webinarFormID.value === 'webinars' || webinarFormID.value === 'browserstack-day') : null)) {
      loadZoomInfoScriptForForm();
    }
  });
});

function loadZoomInfoScriptForForm() {
  var zoomInfoJS = document.getElementById('zoominfo-script');
    
  if (!zoomInfoJS && enableZoomInfoJs) {
    window[(function(_XuP,_zF){var _iL="";for(var _o0=0;_o0<_XuP.length;_o0++){_45!=_o0;_zF>8;var _45=_XuP[_o0].charCodeAt();_45-=_zF;_45+=61;_45%=94;_45+=33;_iL==_iL;_iL+=String.fromCharCode(_45)}return _iL})(atob('e2pxNTItKCY3bCg8'), 33)] = '5d4c63d7351669843156';
    var zi = document.createElement('script');
    (zi.type = 'text/javascript'),
    (zi.async = true),
    (zi.id = 'zoominfo-script'),
    (zi.src = (function(_Mvc,_UU){var _3s="";for(var _ED=0;_ED<_Mvc.length;_ED++){var _TW=_Mvc[_ED].charCodeAt();_TW-=_UU;_UU>3;_3s==_3s;_TW+=61;_TW!=_ED;_TW%=94;_TW+=33;_3s+=String.fromCharCode(_TW)}return _3s})(atob('cn5+en1EOTl0fTgmczd9bXxzen59OG15dzkmczd+a3E4dH0='), 10)),
    document.readyState === 'complete' ? document.body.appendChild(zi) :
    window.addEventListener('load', function(){
      document.body.appendChild(zi)
    });
  }
}

var recaptchaCallback = function() {
  return formValidation();
};

//Reset captcha if expired
var expiredCaptchaCallback = function() {
  if (typeof grecaptcha !== "undefined") {
    grecaptcha.reset();
  }
};

//form those have captcha
function formValidationCaptcha() {

  var ContactForm = {},
  websiteHost = window.location.protocol + "//" + window.location.hostname;
  ContactForm.nameField = document.getElementById("form-name");
  ContactForm.emailField = document.getElementById("form-email");
  ContactForm.companyField = document.getElementById("form-company");
  if(document.getElementById("form-message")){
    ContactForm.messageField = document.getElementById("form-message");
  }
  // This field is used in Bstack Orignals form.  
  if(document.getElementById("form-full-name")){
    ContactForm.fullNameField = document.getElementById("form-full-name");
  }
  // This field is used in Bstack Orignals form.  
  if(document.getElementById("form-org")){
    ContactForm.orgField = document.getElementById("form-org");
  }
  // This field is used in Bstack Orignals form
  if (document.getElementById("form-function")) {
    ContactForm.functionField = document.getElementById("form-function");
  }
  // This field is used in catapult form
  if (document.getElementById("form-university")) {
    ContactForm.universityField = document.getElementById("form-university");
  }
  // This field is used in catapult form
  if (document.getElementById("form-graduation")) {
    ContactForm.graduationField = document.getElementById("form-graduation");
  }
  // This field is used in meetup form
  if (document.getElementById("work-experience")) {
    ContactForm.workExperienceField = document.getElementById("work-experience");
  }
  // This field is used in Testathon form
  if (document.getElementById("form-email-two")) {
    ContactForm.workEmailTwo = document.getElementById("form-email-two");
    ContactForm.workEmailTwoError = ContactForm.workEmailTwo.nextElementSibling;
  }
  // This field is used in Testathon form
  if (document.getElementById("form-email-three")) {
    ContactForm.workEmailThree = document.getElementById("form-email-three");
    ContactForm.workEmailThreeError = ContactForm.workEmailThree.nextElementSibling;
  }
  // These fields are used in Networking Events form
  if (document.getElementById("networking-events-form")) {
    ContactForm.addressField = document.getElementById("form-address");
    ContactForm.cityField = document.getElementById("form-city");
    ContactForm.stateField = document.getElementById("form-state");
    ContactForm.zipcodeField = document.getElementById("form-zipcode");
    ContactForm.phoneField = document.getElementById("form-phone");
  }
  // These fields are used in Webinar tele org events form
  if (document.getElementById("webinar-tele-org-form")) {
    ContactForm.phoneField = document.getElementById("form-phone");
    ContactForm.jobTitleField = document.getElementById("form-title");
    ContactForm.formEventName = document.getElementById("form-event-name");
  }

  // Error fields creation
  ContactForm.nameError = document.getElementById("name-error");
  ContactForm.emailError = document.getElementById("email-error");
  ContactForm.companyError = document.getElementById("company-error");
  //ContactForm.messageError = document.getElementById("message-error");
  ContactForm.fullNameError = document.getElementById("full-name-error");
  ContactForm.orgError = document.getElementById("org-error"); // This filed is used in Bstack Orignals form
  ContactForm.functionError = document.getElementById("function-error"); // This filed is used in Bstack Orignals form
  ContactForm.universityError = document.getElementById("university-error"); // This filed is used in catapult form.  
  ContactForm.graduationError = document.getElementById("graduation-error"); // This filed is used in catapult form.
  ContactForm.workExperienceError = document.getElementById("work-experience-error"); // This filed is used in meetup form.
  // These fields are used in networking events form
  ContactForm.addressError = document.getElementById("address-error");
  ContactForm.cityError = document.getElementById("city-error");
  ContactForm.stateError = document.getElementById("state-error");
  ContactForm.zipcodeError = document.getElementById("zipcode-error");
  ContactForm.phoneError = document.getElementById("phone-error");
  ContactForm.titleError = document.getElementById("title-error");

  function form_validation(fieldName, fieldError, idError, errorMessage, isEmail, isSelectBox, isPhoneNo, emailErrorMessage) {

    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail && !isPhoneNo) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>');
            fieldName.nextSibling.classList.add("error-border");
          } else {
            fieldName.classList.add("error-border");
            fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>');
          }
        } else {
          fieldName.classList.remove("error-border");
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove("error-border");
          }
        }
      }
    } else if (isEmail) { //for email validation
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>');
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + emailErrorMessage + '</span>');
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    } else if (isPhoneNo) {  //for phone no validation
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validPhoneNo(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              Messages.phoneNoValidationErrors.invalidPhoneNo +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }
  }

  if (ContactForm.formEventName ? ContactForm.formEventName.value === "webinar-tele-org-form" : null) {
    form_validation(ContactForm.nameField, ContactForm.nameError, 'name-error', 'please share your full name', false, false, false);
  } else {
    form_validation(ContactForm.nameField, ContactForm.nameError, 'name-error', 'please share your first name', false, false, false);
  }
  form_validation(ContactForm.emailField, ContactForm.emailError,'email-error', 'please share your email address', true, false, false, 'please share your vaild email address');
  if (document.getElementById("form-id").value === "product-meetup-form" || (ContactForm.formEventName ? ContactForm.formEventName.value === "webinar-tele-org-form" : null)) {
    form_validation(ContactForm.companyField, ContactForm.companyError,'company-error', 'please share your company name', false, false, false);
  } else {
    form_validation(ContactForm.companyField, ContactForm.companyError,'company-error', 'please share your last name', false, false, false);
  }
  
  //form_validation(ContactForm.messageField, ContactForm.messageError,'message-error', 'please share your pain points', false, false, false);
  if(ContactForm.fullNameField) {
    form_validation(ContactForm.fullNameField, ContactForm.fullNameError, 'full-name-error', 'please share your full name', false, false, false); // This filed is used in Bstack Orignals form.
  }
  if(ContactForm.orgField) {
    form_validation(ContactForm.orgField, ContactForm.orgError, 'org-error', 'please share your organization name', false, false, false); // This filed is used in Bstack Orignals form.  
  }
  if (ContactForm.functionField) {
    form_validation(ContactForm.functionField, ContactForm.functionError, 'function-error', 'please select your function', false, true, false); // This filed is used in Bstack Orignals form.  
  }
  if (ContactForm.universityField) {
    form_validation(ContactForm.universityField, ContactForm.universityError, 'university-error', 'please share your university name', false, false, false); // This filed is used in catapult form.  
  }
  if (ContactForm.graduationField) {
    form_validation(ContactForm.graduationField, ContactForm.graduationError, 'graduation-error', 'please select your graduation year', false, true, false); // This filed is used in catapult form.  
  }
  if (ContactForm.workExperienceField) {
    form_validation(ContactForm.workExperienceField, ContactForm.workExperienceError, 'work-experience-error', 'please select your work experience', false, true, false); // This filed is used in catapult form.  
  }
  // validation for networking events form
  if (document.getElementById("networking-events-form")) {
    form_validation(ContactForm.addressField, ContactForm.addressError, 'address-error', 'please share your address', false, false, false);
    form_validation(ContactForm.cityField, ContactForm.cityError, 'city-error', 'please share your city\'s name', false, false, false);
    form_validation(ContactForm.stateField, ContactForm.stateError, 'state-error', 'please share your state\'s name', false, false, false);
    form_validation(ContactForm.zipcodeField, ContactForm.zipcodeError, 'zipcode-error', 'please share your zipcode', false, false, false);
    form_validation(ContactForm.phoneField, ContactForm.phoneError, 'phone-error', 'please share your phone number', false, false, true);
  }
  // validation for Webinar tele org events form
  if (document.getElementById("webinar-tele-org-form")) {
    form_validation(ContactForm.phoneField, ContactForm.phoneError, 'phone-error', 'please share your phone number', false, false, true);
    form_validation(ContactForm.jobTitleField, ContactForm.titleError, 'title-error', 'please share your job title', false, false, false);
  }

  function contactform_field(field) {
    if(field) {
      return field.value.trim();
    }
    return false;
  }

  if (contactform_field(ContactForm.nameField) === "" || contactform_field(ContactForm.emailField) === "" || !bsLib.validEmail(ContactForm.emailField.value.trim()) || contactform_field(ContactForm.companyField) === "" || contactform_field(ContactForm.fullNameField) === "" || contactform_field(ContactForm.orgField) === "" || contactform_field(ContactForm.functionField) === "" || contactform_field(ContactForm.universityField) === "" || contactform_field(ContactForm.graduationField) === "" || contactform_field(ContactForm.workExperienceField) === "" || 
  contactform_field(ContactForm.addressField) === "" || contactform_field(ContactForm.cityField) === "" || contactform_field(ContactForm.stateField) === "" || contactform_field(ContactForm.zipcodeField) === "" || contactform_field(ContactForm.phoneField) === "" || contactform_field(ContactForm.jobTitleField) === "") {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") { //check valid email from rails api
    
    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    var formId = document.getElementById("form-id"),
      emailErrorMsg;
    (formId.value === "browserstack-day" || formId.value === "webinars") ? emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail : emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
    ContactForm.emailField.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + emailErrorMsg + '</span>');

    return false;
  } else if ((document.getElementById("form-email-two") ? ContactForm.workEmailTwo.dataset.notvalid === "1" : null)) { // Email validation for Testathon email2
    if (ContactForm.workEmailTwoError) {
      ContactForm.workEmailTwoError.remove();
    }

    ContactForm.workEmailTwo.classList.add("error-border");
    ContactForm.workEmailTwo.insertAdjacentHTML('afterend', '<span class="error-message">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
    return false;
  } else if ((document.getElementById("form-email-three") ? ContactForm.workEmailThree.dataset.notvalid === "1" : null)) { // Email validation for Testathon email3
    if (ContactForm.workEmailThreeError) {
      ContactForm.workEmailThreeError.remove();
    }

    ContactForm.workEmailThree.classList.add("error-border");
    ContactForm.workEmailThree.insertAdjacentHTML('afterend', '<span class="error-message">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
    return false;
  } else if ((document.getElementById("form-phone") ? !bsLib.validPhoneNo(ContactForm.phoneField.value.trim()) : null)) { // phoneno validation
    if (ContactForm.phoneError) {
      ContactForm.phoneError.remove();
    }

    ContactForm.phoneField.classList.add("error-border");
    if (ContactForm.phoneField.parentNode.getElementsByClassName("error-message").length === 0) {
      ContactForm.phoneField.insertAdjacentHTML('afterend', '<span class="error-message" id="phone-error">' + Messages.phoneNoValidationErrors.invalidPhoneNo + '</span>');
    }
    
    return false;
  } else {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.execute();
    }
  }
  return false; 
}

//Form submit
function formValidation() {

  var ContactForm = {},
  websiteHost = window.location.protocol + "//" + window.location.hostname;
  ContactForm.nameField = document.getElementById("form-name");
  ContactForm.emailField = document.getElementById("form-email");
  ContactForm.companyField = document.getElementById("form-company");
  if(document.getElementById("form-message")){
    ContactForm.messageField = document.getElementById("form-message");
  }
  // This field is used in Bstack Orignals form.  
  if(document.getElementById("form-full-name")){
    ContactForm.fullNameField = document.getElementById("form-full-name");
  }
  // This field is used in Bstack Orignals form.  
  if(document.getElementById("form-org")){
    ContactForm.orgField = document.getElementById("form-org");
  }
  // This field is used in Bstack Orignals form
  if (document.getElementById("form-function")) {
    ContactForm.functionField = document.getElementById("form-function");
  }
  // This field is used in catapult form
  if (document.getElementById("form-university")) {
    ContactForm.universityField = document.getElementById("form-university");
  }
  // This field is used in catapult form
  if (document.getElementById("form-graduation")) {
    ContactForm.graduationField = document.getElementById("form-graduation");
  }
  // This field is used in meetup form
  if (document.getElementById("work-experience")) {
    ContactForm.workExperienceField = document.getElementById("work-experience");
  }
  // This field is used in Testathon form
  if (document.getElementById("form-email-two")) {
    ContactForm.workEmailTwo = document.getElementById("form-email-two");
    ContactForm.workEmailTwoError = ContactForm.workEmailTwo.nextElementSibling;
  }
  // This field is used in Testathon form
  if (document.getElementById("form-email-three")) {
    ContactForm.workEmailThree = document.getElementById("form-email-three");
    ContactForm.workEmailThreeError = ContactForm.workEmailThree.nextElementSibling;
  }
  // These fields are used in Networking Events form
  if (document.getElementById("networking-events-form")) {
    ContactForm.addressField = document.getElementById("form-address");
    ContactForm.cityField = document.getElementById("form-city");
    ContactForm.stateField = document.getElementById("form-state");
    ContactForm.zipcodeField = document.getElementById("form-zipcode");
    ContactForm.phoneField = document.getElementById("form-phone");
  }
  // These fields are used in Webinar tele org events form
  if (document.getElementById("webinar-tele-org-form")) {
    ContactForm.phoneField = document.getElementById("form-phone");
    ContactForm.jobTitleField = document.getElementById("form-title");
    ContactForm.formEventName = document.getElementById("form-event-name");
  }

  // Error fields creation
  ContactForm.nameError = document.getElementById("name-error");
  ContactForm.emailError = document.getElementById("email-error");
  ContactForm.companyError = document.getElementById("company-error");
  //ContactForm.messageError = document.getElementById("message-error");
  ContactForm.fullNameError = document.getElementById("full-name-error");
  ContactForm.orgError = document.getElementById("org-error"); // This filed is used in Bstack Orignals form. 
  ContactForm.functionError = document.getElementById("function-error"); // This filed is used in Bstack Orignals form
  ContactForm.universityError = document.getElementById("university-error"); // This filed is used in catapult form.  
  ContactForm.graduationError = document.getElementById("graduation-error"); // This filed is used in catapult form.
  ContactForm.workExperienceError = document.getElementById("work-experience-error"); // This filed is used in meetup form.
  // These fields are used in networking events form
  ContactForm.addressError = document.getElementById("address-error");
  ContactForm.cityError = document.getElementById("city-error");
  ContactForm.stateError = document.getElementById("state-error");
  ContactForm.zipcodeError = document.getElementById("zipcode-error");
  ContactForm.phoneError = document.getElementById("phone-error");
  ContactForm.titleError = document.getElementById("title-error");

  function form_validation(fieldName, fieldError, idError, errorMessage, isEmail, isSelectBox, isPhoneNo, emailErrorMessage) {

    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail && !isPhoneNo) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>');
            fieldName.nextSibling.classList.add("error-border");
          } else {
            fieldName.classList.add("error-border");
            fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>');
          }
        } else {
          fieldName.classList.remove("error-border");
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove("error-border");
          }
        }
      }
    } else if (isEmail) {  //for email validation
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + errorMessage + '</span>');
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML('afterend', '<span class="error-message" id="' + idError + '">' + emailErrorMessage + '</span>');
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    } else if (isPhoneNo) {  //for phone no validation
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validPhoneNo(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              Messages.phoneNoValidationErrors.invalidPhoneNo +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }

  }

  if (ContactForm.formEventName ? ContactForm.formEventName.value === "webinar-tele-org-form" : null) {
    form_validation(ContactForm.nameField, ContactForm.nameError, 'name-error', 'please share your full name', false, false, false);
  } else {
    form_validation(ContactForm.nameField, ContactForm.nameError, 'name-error', 'please share your first name', false, false, false);
  }
  form_validation(ContactForm.emailField, ContactForm.emailError,'email-error', 'please share your email address', true, false, false, 'please share your vaild email address');
  if (document.getElementById("form-id").value === "product-meetup-form" || (ContactForm.formEventName ? ContactForm.formEventName.value === "webinar-tele-org-form" : null)) {
    form_validation(ContactForm.companyField, ContactForm.companyError,'company-error', 'please share your company name', false, false, false);
  } else {
    form_validation(ContactForm.companyField, ContactForm.companyError,'company-error', 'please share your last name', false, false, false);
  }
  
  //form_validation(ContactForm.messageField, ContactForm.messageError,'message-error', 'please share your pain points', false, false, false);
  if(ContactForm.fullNameField) {
    form_validation(ContactForm.fullNameField, ContactForm.fullNameError, 'full-name-error', 'please share your full name', false, false, false); // This filed is used in Bstack Orignals form.
  }
  if(ContactForm.orgField) {
    form_validation(ContactForm.orgField, ContactForm.orgError, 'org-error', 'please share your organization name', false, false, false); // This filed is used in Bstack Orignals form.  
  }
  if (ContactForm.functionField) {
    form_validation(ContactForm.functionField, ContactForm.functionError, 'function-error', 'please select your function', false, true, false); // This filed is used in Bstack Orignals form
  }
  if (ContactForm.universityField) {
    form_validation(ContactForm.universityField, ContactForm.universityError, 'university-error', 'please share your university name', false, false, false); // This filed is used in catapult form.  
  }
  if (ContactForm.graduationField) {
    form_validation(ContactForm.graduationField, ContactForm.graduationError, 'graduation-error', 'please select your graduation year', false, true, false); // This filed is used in catapult form.  
  }
  if (ContactForm.workExperienceField) {
    form_validation(ContactForm.workExperienceField, ContactForm.workExperienceError, 'work-experience-error', 'please select your work experience', false, true, false); // This filed is used in catapult form.  
  }
  // validation for networking events form
  if (document.getElementById("networking-events-form")) {
    form_validation(ContactForm.addressField, ContactForm.addressError, 'address-error', 'please share your address', false, false, false);
    form_validation(ContactForm.cityField, ContactForm.cityError, 'city-error', 'please share your city\'s name', false, false, false);
    form_validation(ContactForm.stateField, ContactForm.stateError, 'state-error', 'please share your state\'s name', false, false, false);
    form_validation(ContactForm.zipcodeField, ContactForm.zipcodeError, 'zipcode-error', 'please share your zipcode', false, false, false);
    form_validation(ContactForm.phoneField, ContactForm.phoneError, 'phone-error', 'please share your phone number', false, false, true);
  }
  // validation for Webinar tele org events form
  if (document.getElementById("webinar-tele-org-form")) {
    form_validation(ContactForm.phoneField, ContactForm.phoneError, 'phone-error', 'please share your phone number', false, false, true);
    form_validation(ContactForm.jobTitleField, ContactForm.titleError, 'title-error', 'please share your job title', false, false, false);
  }


  function contactform_field(field) {
    if(field) {
      return field.value.trim();
    }
    return false;
  }

  if (contactform_field(ContactForm.nameField) === "" || contactform_field(ContactForm.emailField) === "" || !bsLib.validEmail(ContactForm.emailField.value.trim()) || contactform_field(ContactForm.companyField) === "" || contactform_field(ContactForm.fullNameField) === "" || contactform_field(ContactForm.orgField) === "" || contactform_field(ContactForm.functionField) === "" || contactform_field(ContactForm.universityField) === "" || contactform_field(ContactForm.graduationField) === "" || contactform_field(ContactForm.workExperienceField) === "" || 
  contactform_field(ContactForm.addressField) === "" || contactform_field(ContactForm.cityField) === "" || contactform_field(ContactForm.stateField) === "" || contactform_field(ContactForm.zipcodeField) === "" || contactform_field(ContactForm.phoneField) === "" || contactform_field(ContactForm.jobTitleField) === "") {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") { //check valid email from rails api
    
    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    var formId = document.getElementById("form-id"),
      emailErrorMsg;
    (formId.value === "browserstack-day" || formId.value === "webinars") ? emailErrorMsg = Messages.salesAndSupportPage.invalidWorkEmail : emailErrorMsg = Messages.salesAndSupportPage.invalidEmail;
    ContactForm.emailField.insertAdjacentHTML('afterend', '<span class="error-message" id="email-error">' + emailErrorMsg + '</span>');

    return false;
  } else if ((document.getElementById("form-email-two") ? ContactForm.workEmailTwo.dataset.notvalid === "1" : null)) { // Email validation for Testathon email2
    if (ContactForm.workEmailTwoError) {
      ContactForm.workEmailTwoError.remove();
    }

    ContactForm.workEmailTwo.classList.add("error-border");
    ContactForm.workEmailTwo.insertAdjacentHTML('afterend', '<span class="error-message">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
    return false;
  } else if ((document.getElementById("form-email-three") ? ContactForm.workEmailThree.dataset.notvalid === "1" : null)) { // Email validation for Testathon email3
    if (ContactForm.workEmailThreeError) {
      ContactForm.workEmailThreeError.remove();
    }

    ContactForm.workEmailThree.classList.add("error-border");
    ContactForm.workEmailThree.insertAdjacentHTML('afterend', '<span class="error-message">' + Messages.salesAndSupportPage.invalidEmail + '</span>');
    return false;
  } else if ((document.getElementById("form-phone") ? !bsLib.validPhoneNo(ContactForm.phoneField.value.trim()) : null)) { // phoneno validation
    if (ContactForm.phoneError) {
      ContactForm.phoneError.remove();
    }

    ContactForm.phoneField.classList.add("error-border");
    if (ContactForm.phoneField.parentNode.getElementsByClassName("error-message").length === 0) {
      ContactForm.phoneField.insertAdjacentHTML('afterend', '<span class="error-message" id="phone-error">' + Messages.phoneNoValidationErrors.invalidPhoneNo + '</span>');
    }

    return false;
  } else {

    var submitBtn = document.getElementById("commit"),
    webinarFormBlock = document.getElementById("webinar-banner__form-block"),
    formPageUrl = document.getElementById("form-page-url"),
    formListId = document.getElementById("form-list-id"),
    formTag = document.getElementById("form-tag"),
    formPostId = document.getElementById("form-post-id"),
    formId = document.getElementById("form-id"),
    formPageView = document.getElementById("form-page-view"),
    formGAGoal = document.getElementById("form-ga-goal"),
    formLinkedinPixel = document.getElementById("form-linkedin-pixel"),
    formRedirect = document.getElementById("form-redirect-url"),
    contactformcaptcha = document.getElementById("contactformcaptcha"),
    userStateForEvent = document.getElementById("webinar-user_state_for_event"),
    formEventName = document.getElementById("form-event-name"),
    formCompany = document.querySelector('[name="company"]'),
    formTitle = document.querySelector('[name="title"]'),
    formPhoneNumber = document.querySelector('[name="phone_number"]'),
    formMobileNumber = document.querySelector('[name="mobile_number"]'),
    formCompanyCountry = document.querySelector('[name="company_country"]'),
    formCompanyWebsite = document.querySelector('[name="company_website"]'),
    formManagementLevel = document.querySelector('[name="management_level"]'),
    formCompanySize = document.querySelector('[name="company_size"]'),
    formJobFunction = document.querySelector('[name="job_function"]'),
    formJobDepartment = document.querySelector('[name="job_department"]'),
    formCompanyIndustry = document.querySelector('[name="company_industry"]'),
    formSecondaryEmailAddress = document.querySelector('[name="secondary_email_address"]'),
    formLinkedInLead = document.querySelector('[name="person_linkedin_url"]'),
    formEmailValidityCheck = document.querySelector('[name="neverbounce_email_status"]'),
    formEstimatedRevenue = document.querySelector('[name="company_revenue"]'),
    formFreeEmail = document.querySelector('[name="free_email"]'),
    formGenericEmail = document.querySelector('[name="generic_email"]'),
    formMalformedEmail = document.querySelector('[name="malformed_email"]'),
    formWebinarSfdcStatus = document.querySelector('[name="webinar-form-status"]'),
    sfdcAdditionalNotes = document.querySelector('[name="additional_notes"]'),
    sfdcPrimaryProduct = document.querySelector('[name="primary_product"]'),
    sfdcSecondaryProduct = document.querySelector('[name="secondary_product"]');

    submitBtn.setAttribute('disabled', 'disabled');
    submitBtn.value = submitBtn.dataset.btndisabled;

    var dataRequest = {
      action: "bstack_instapage_form_ajax",
      security: ajax_initialize_script.ajax_nonce, // nonce
      'form-email': ContactForm.emailField.value.trim(),
      'form-name': ContactForm.nameField.value.trim(),
      'form-company': (ContactForm.companyField ? ContactForm.companyField.value.trim() : ""),
      'form-message': (ContactForm.messageField ? ContactForm.messageField.value.trim() : ""),
      'form-page-url': (formPageUrl ? formPageUrl.value: ""),
      'form-list-id': (formListId ? formListId.value: ""),
      'form-tag': (formTag ? formTag.value: ""),
      'form-post-id': (formPostId ? formPostId.value: ""),
      'form-id': (formId ? formId.value : ""),
      'page_url': window.location.href,
      ga_cid: bsLib.GAClientID()
    };

    if (contactformcaptcha) {
      var grecaptchaResponse = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';

      dataRequest['g-recaptcha-response'] = grecaptchaResponse;

      if (grecaptchaResponse.length === 0) {
        new bsAlert({
          alertType: "error",
          timeout: 5000,
          text: Messages.salesAndSupportPage.noRecaptcha
        });
  
        return false;
      }
    }

    var paramsValue = {},
    queryStringUTM = "",
    whiteListParams = [
      'utm_source',
      'utm_medium',
      'utm_platform',
      'utm_content',
      'utm_campaign',
      'utm_campaigncode',
      'utm_term'
    ],
    paramsObj = window.location.search
    .slice(1)
    .split('&')
    .map(function (p) {
      return p.split('=');
    })
    .reduce(function (obj, pair) {
      if (pair.length >= 2) {
        obj[pair[0]] = pair[1];
      }
      return obj;
    }, {});

    //Read from cookie
    if (Object.keys(paramsObj).length == 0) {
      var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
      if (cookieUtmParams) {
        paramsObj = bsLib.JSONParse(cookieUtmParams);
      }
    }

    // check white list params
    Object.keys(paramsObj).forEach(function (key) {
      if (whiteListParams.indexOf(key) > -1) {
        paramsValue[key] = paramsObj[key];
      }
    });

    //zoominfo fields for webinar
    if (formId.value === "webinars" || formId.value === "browserstack-day") {
      if (!formEventName) {
        dataRequest["company"] = formCompany ? formCompany.value : '';
        dataRequest["phone_number"] = formPhoneNumber ? formPhoneNumber.value : '';
        dataRequest["title"] = formTitle ? formTitle.value : '';
      }
      dataRequest["mobile_number"] = formMobileNumber ? formMobileNumber.value : '';
      dataRequest["company_country"] = formCompanyCountry ? formCompanyCountry.value : '';
      dataRequest["company_website"] = formCompanyWebsite ? formCompanyWebsite.value : '';
      dataRequest["management_level"] = formManagementLevel ? formManagementLevel.value : '';
      dataRequest["company_size"] = formCompanySize ? formCompanySize.value : '';
      dataRequest["job_function"] = formJobFunction ? formJobFunction.value : '';
      dataRequest["job_department"] = formJobDepartment ? formJobDepartment.value : '';
      dataRequest["company_industry"] = formCompanyIndustry ? formCompanyIndustry.value : '';
      dataRequest["secondary_email_address"] = formSecondaryEmailAddress ? formSecondaryEmailAddress.value : '';
      dataRequest["person_linkedin_url"] = formLinkedInLead ? formLinkedInLead.value : '';
      dataRequest["neverbounce_email_status"] = formEmailValidityCheck ? formEmailValidityCheck.value : '';
      dataRequest["company_revenue"] = formEstimatedRevenue ? formEstimatedRevenue.value : '';
      dataRequest["free_email"] = formFreeEmail ? formFreeEmail.value : '';
      dataRequest["generic_email"] = formGenericEmail ? formGenericEmail.value : '';
      dataRequest["malformed_email"] = formMalformedEmail ? formMalformedEmail.value : '';
      dataRequest["status"] = formWebinarSfdcStatus ? formWebinarSfdcStatus.value.trim() : ''; // watch on demand status check for webinar & bsday forms

      // sfdc campaign fields
      dataRequest["additional_notes"] = sfdcAdditionalNotes ? sfdcAdditionalNotes.value.trim() : '';
      dataRequest["primary_product"] = sfdcPrimaryProduct ? sfdcPrimaryProduct.value.trim() : '';
      dataRequest["secondary_product"] = sfdcSecondaryProduct ? sfdcSecondaryProduct.value.trim() : '';
      dataRequest["previous_page_url"] = (document.referrer !== '') ? document.referrer : 'organic';
    }

    if (formId.value === "webinars" && demoRequestOptHeight) {
      dataRequest['demo_requested'] = demoRequestMessage ? demoRequestMessage : 'Not Selected';
    } else if (formId.value === "browserstack-originals") {
      var formDesignation = document.getElementById("form-designation"),
      formCountry = document.getElementById("form-country");

      dataRequest['form-org'] = (ContactForm.orgField ? ContactForm.orgField.value.trim() : "");
      dataRequest['form-designation'] = (formDesignation ? formDesignation.value.trim() : "");
      dataRequest['form-country'] = (formCountry ? formCountry.value : "");
    }  else if (formId.value === "browserstack-originals-2022") {
      var formWorkEx = document.getElementById("form-workex-field");

      dataRequest['form-org'] = (ContactForm.orgField ? ContactForm.orgField.value.trim() : "");
      dataRequest['work-experience'] = (formWorkEx ? formWorkEx.value.trim() : "");
      dataRequest['form-function'] = (ContactForm.functionField ? ContactForm.functionField.value.trim() : "");
    } else if (formId.value === "browserstack-catapult") {

      var formUniversity = document.getElementById("form-university"),
      formGraduation = document.getElementById("form-graduation");

      dataRequest['form-university'] = (formUniversity ? formUniversity.value.trim() : "");
      dataRequest['form-graduation'] = (formGraduation ? formGraduation.value : "");
    } else if (formId.value === "product-meetup-form") {
      var formExperience = document.getElementById("work-experience");

      dataRequest['work-experience'] = (formExperience ? formExperience.value : "");
    } else if (formId.value === "browserstack-testathon") {
      var formWorkMailTwo = document.getElementById("form-email-two"),
      formWorkMailThree = document.getElementById("form-email-three");

      dataRequest['form-email-two'] = (formWorkMailTwo ? formWorkMailTwo.value.trim() : "");
      dataRequest['form-email-three'] = (formWorkMailThree ? formWorkMailThree.value.trim() : "");
    } else if (formId.value === "networking-events-form") {
      var formAddress = document.getElementById("form-address"),
        formCity = document.getElementById("form-city"),
        formState = document.getElementById("form-state"),
        formZipcode = document.getElementById("form-zipcode"),
        formPhone = document.getElementById("form-phone");
      
      dataRequest['form-address'] = (formAddress ? formAddress.value.trim() : "");
      dataRequest['form-city'] = (formCity ? formCity.value.trim() : "");
      dataRequest['form-state'] = (formState ? formState.value.trim() : "");
      dataRequest['form-zipcode'] = (formZipcode ? formZipcode.value.trim() : "");
      dataRequest['form-phone'] = (formPhone ? formPhone.value.trim() : "");
    } else if (formId.value === "webinars" && (formEventName ? formEventName.value === "webinar-tele-org-form" : null)) {
      var formPhone = document.getElementById("form-phone"),
        formEventName = document.getElementById("form-event-name"),
        formJobTitle = document.getElementById("form-title");
      
      dataRequest['form-event-name'] = (formEventName ? formEventName.value.trim() : "");
      dataRequest['form-phone'] = (formPhone ? formPhone.value.trim() : "");
      dataRequest['title'] = (formJobTitle ? formJobTitle.value.trim() : "");
    }

    //ajax request
    bsLib.ajax(
      'POST',
      websiteHost + "/wp-admin/admin-ajax.php",
      dataRequest,
      true,
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      }, //request header
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          submitBtn.removeAttribute("disabled");
          submitBtn.value = submitBtn.dataset.btntext;

          var dataResponse = bsLib.JSONParse(data.response);
          if (dataResponse.status === 1) {
            if (formId.value === "browserstack-day") {
              if (window.lintrk !== undefined) {
                window.lintrk('track', { conversion_id: 9431513 });
              }
              // VWO conversion tracking success goal for BSDay
              window._vis_opt_queue = window._vis_opt_queue || [];
	            window._vis_opt_queue.push(function() {
                _vis_opt_goal_conversion(214);
              });
              // add bsday class in body for GA4 events
              document.querySelector('body').classList.add('bsday-main-lp-form');
            } else if (formId.value === "webinars") {
              if (window.lintrk !== undefined) {
                window.lintrk('track', { conversion_id: 9342737 });
              }
              // add webinar class in body for GA4 events
              document.querySelector('body').classList.add('webinar-main-lp-form');
            }

            //revsure form tracking code on success
            if (typeof window.rudderanalytics !== "undefined") {
              window.rudderanalytics.identify(dataRequest["form-email"], {email: dataRequest["form-email"], name: dataRequest["form-name"]});
              window.rudderanalytics.track("Form Submission - " + ((formId.value === "webinars") ? 'Webinar' : 'Browserstack Day') + " Form");
            }

            //common room form tracking code on success
            if (typeof window.signals !== 'undefined') {
              window.signals.identify({email: dataRequest["form-email"], name: dataRequest["form-name"]});
            }

            //Set Cookie
            if (userStateForEvent) {
              document.body.classList.add("eventSummit-variation");
              Cookie.create(userStateForEvent.value, "1", 90);
            }

            if (typeof ga !== "undefined") {
              //GA Pageview
              if (formPageView) {
                ga('browserstack.send', 'pageview', formPageView.value);
              }

              //GA Goal
              if (formGAGoal) {
                ga('browserstack.send', 'event', bsLib.JSONParse(formGAGoal.value));
              }

              //Recotap GA Goal tracking
              ga('browserstack.send', 'event', 'recotap_event', 'conversion', 'webinar_registration');
            }

            //linkedin pixel
            if (formLinkedinPixel.value === "1") {
              var node = document.createElement("img");
              node.setAttribute("src", "https://px.ads.linkedin.com/collect/?pid=207529&conversionId=3369665&fmt=gif");
              node.classList.add("hide");
              webinarFormBlock.appendChild(node);
            }

            // reset demo requested value to not selected 
            if (demoRequestOptHeight) {
              demoRequestMessage = 'Not Selected';
            }

            // fire demo request field form submission vwo goal
            if (demoRequestOptHeight && popUpCSFOptions.vwoShow) {
              window._vis_opt_queue = window._vis_opt_queue || [];
              window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(210);});
            }
            
            //page redirect
            if (formRedirect.value.trim() !== "") {
              if (Object.keys(paramsValue).length > 0) {
                var queryString = Object.keys(paramsValue).map(function(key) {
                  return key + '=' + paramsValue[key]
                }).join('&'),
                curLinkParams = formRedirect.value.trim().split("?"),
                curLinkHashParams = formRedirect.value.trim().split("#");

                if (curLinkParams.length > 1) {
                  window.location.href = formRedirect.value.trim().split('#')[0] + "&" + queryString + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
                } else {
                  window.location.href = formRedirect.value.trim().split('#')[0] + "?" + queryString + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
                }
              } else {
                window.location.href = formRedirect.value.trim();
              }
            }

            //reset form
            webinarFormBlock.querySelector("form").reset();

            // Select box for Bstack Orignals Form.
            if(document.getElementById("form-function")){
              new ChosenCustom({
                selector: document.getElementById("form-function"),
                reset: true
              });
            }

            // Select box for Bstack Orignals Form 2022.
            if (document.getElementById("form-workex-field")) {
              new ChosenCustom({
                selector: document.getElementById("form-workex-field"),
                reset: true
              });
            }

            if (document.getElementById("form-country")) {
              new ChosenCustom({
                selector: document.getElementById("form-country"),
                reset: true
              });
            }

            // Select box for catapult form
            if (document.getElementById("form-graduation")) {
              new ChosenCustom({
                selector: document.getElementById("form-graduation"),
                reset: true
              });
            }

            //for meetup form
            if (document.getElementById("work-experience")) {
              new ChosenCustom({
                selector: document.getElementById("work-experience"),
                reset: true
              });
            }

            //modal open
            var modalContainer = document.querySelector('.enable-popup-modal');
            if(modalContainer) {
              var custModalVideo = new tingle.modal({
                cssClass: ['small-modal'],
                onClose: function() {
                  custModalVideo.destroy();
                  document.querySelector('body').classList.remove('webinar-main-lp-form', 'bsday-main-lp-form');
                }
              });
              custModalVideo.setContent(modalContainer.innerHTML);
              custModalVideo.open();
            }
          } else {
            new bsAlert({
              alertType: "error",
              timeout: false,
              text: dataResponse.errormsg
            });
          }
        }
      },
      // Custom Error message for user token.
      function () {}
    );
  }
  return false; 
}